module.exports = __webpack_public_path__ + "7b842c9527b5fb83583b80d9da6da1eb.woff";